import React from 'react';
import { useHistory } from 'react-router-dom';

import PortalSessionContext from '../../contexts/PortalSessionContext/PortalSessionContext';

const UserOnly = ({ children }) => {
	const { user } = React.useContext(PortalSessionContext);
	const history = useHistory();

	React.useEffect(() => {
		if (!user?.id) {
			history.push('/');
		}
	});

	return children;
};

export default UserOnly;
